import PropTypes from 'prop-types';

export const heroHeaderContent = {
  title: 'Info centre',
  paragraph:
    'Everything you need to know about urinary tract infections. Learn more about UTI causes, symptoms, treatment and how you can feel better and stay well.',
};

export const imageShape = {
  contentType: PropTypes.string,
  description: PropTypes.string,
  height: PropTypes.number,
  title: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.number,
};

export const categoryShape = {
  createdAt: PropTypes.string,
  icon: PropTypes.shape(imageShape),
  length: PropTypes.string,
  lengthDescribed: PropTypes.string,
  linkAs: PropTypes.string,
  linkHref: PropTypes.string,
  reviewer: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  updatedAt: PropTypes.string,
};

export const subcategoryShape = {
  category: PropTypes.shape(categoryShape),
  createdAt: PropTypes.string,
  length: PropTypes.string,
  lengthDescribed: PropTypes.string,
  linkAs: PropTypes.string,
  linkHref: PropTypes.string,
  reviewer: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  updatedAt: PropTypes.string,
};

export const articleShape = {
  category: PropTypes.shape(categoryShape),
  createdAt: PropTypes.string,
  image: PropTypes.shape(imageShape),
  isVideo: PropTypes.bool,
  length: PropTypes.string,
  lengthDescribed: PropTypes.string,
  linkAs: PropTypes.string,
  linkHref: PropTypes.string,
  promoTitle: PropTypes.string,
  reviewer: PropTypes.string,
  richText: PropTypes.object,
  slug: PropTypes.string,
  subcategory: PropTypes.shape(subcategoryShape),
  thumbnail: PropTypes.shape(imageShape),
  title: PropTypes.string,
  updatedAt: PropTypes.string,
  videoUrl: PropTypes.string,
};

export const postShape = {
  category: PropTypes.shape(categoryShape),
  createdAt: PropTypes.string,
  image: PropTypes.shape(imageShape),
  isVideo: PropTypes.bool,
  length: PropTypes.string,
  lengthDescribed: PropTypes.string,
  linkAs: PropTypes.string,
  linkHref: PropTypes.string,
  promoTitle: PropTypes.string,
  slug: PropTypes.string,
  subcategory: PropTypes.shape(subcategoryShape),
  richText: PropTypes.object,
  thumbnail: PropTypes.shape(imageShape),
  reviewer: PropTypes.string,
  title: PropTypes.string,
  updatedAt: PropTypes.string,
  videoUrl: PropTypes.string,
};

export const promosShape = {
  articles: PropTypes.arrayOf(PropTypes.shape(articleShape)),
  ctaLinkAs: PropTypes.string,
  ctaLinkHref: PropTypes.string,
  ctaText: PropTypes.string,
  linkedCta: PropTypes.oneOfType([
    PropTypes.shape(categoryShape),
    PropTypes.shape(subcategoryShape),
  ]),
  title: PropTypes.string,
};

export const entriesShape = {
  items: PropTypes.array,
  limit: PropTypes.number,
  skip: PropTypes.number,
  total: PropTypes.number,
};

export const menuItemShape = {
  icon: PropTypes.shape(imageShape),
  label: PropTypes.string,
  href: PropTypes.string,
  slug: PropTypes.string,
};
